var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rulebox"},[_c('avue-form',_vm._g(_vm._b({attrs:{"option":_vm.finalOption}},'avue-form',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }